import { customAxiosInstanceMutator } from './custom-axios-instance';
export const cappedInitiationCalculatorVersion = 'INDIVIDUAL-PAYDAY-SCENARIO-V3-CAPPED-INITIATION';
export const formulaInitiationCalculatorVersion = 'INDIVIDUAL-PAYDAY-SCENARIO-V4-FORMULA-INITIATION';
export interface PaydaySchedule {
  advanceDate: string; firstDueDate: string; payday: number; instalments: number;
  missingDayRule: 'REJECT' | 'CLAMP_TO_MONTH_END'; nonWorkingDayRule: 'KEEP_CONTRACTUAL_DATE';
}
export interface ComparisonInput {
  applicantId?: string;
  expectedRevision: number; grossAdvance: string; advanceDate: string; instalments: number;
  repaymentMethod: string; classification: string; paymentDayTiming: string;
  firstDueMonth?: string;
  paydaySchedule?: PaydaySchedule;
}
export interface Comparison {
  policyId: string; revision: number; status: string; calculatorVersion: string; ruleBasis: string; limitation: string;
  scenario: {
    monthlyPercent: number; dayCount: string; rounding: string; repaymentMethod: string; classification: string;
    initiationBase?: number | null; monthlyServiceBase: number; initiationTreatment: string;
    initiationTax: { treatment: string; percent: number; evidenceReference: string };
    serviceTax: { treatment: string; percent: number; evidenceReference: string };
    schedule: { principal: number; advanceDate: string; instalmentCount: number; paymentDayTiming: string };
  };
  funding: { cashReceived: number; feePaidSeparately: number; feeFinanced: number; feeDeductedFromPayout: number;
    initiationCharge?: { baseAmount: number; taxAmount: number; totalAmount: number } };
  instalments: { dueDate: string; principal: number; interest: number; serviceBase: number; serviceTax: number; payment: number; closingBalance: number }[];
  scheduledRepayments: number; totalCustomerOutflow: number; totalCostOfCredit: number; totalInterest: number; totalServiceBase: number; totalTax: number;
}
export const comparePricing = (id: string, input: ComparisonInput) => customAxiosInstanceMutator<Comparison>({
  url: `/loan/api/v1/settings/individual-pricing/drafts/${encodeURIComponent(id)}/preview`, method: 'POST', data: input,
});
export function comparisonError(e: any): string {
  const status = e?.response?.status;
  if (status === 401) return 'Sign in again to calculate.';
  if (status === 403) return 'Your account needs pricing-reader permission.';
  if (status === 409) return 'This draft changed. Return to the draft and reload the list.';
  if (status === 400) return 'Check the scenario and draft settings: cash principal up to R8,000 excluding financed fees and VAT, 1–6 payments, first repayment after advance matching payday, final payment within six months, and valid fees, rates, tax and rounding. Payday quotations require financed initiation.';
  if (status === 422) return 'This draft lacks the supported rule basis. Create a new pricing draft for preview; do not reuse an old synthetic test draft.';
  return 'Calculation unavailable. Retry or reload the loan API. No changes were saved.';
}
